"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Timeline body/grid
 */
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_virtualized_1 = require("react-virtualized");
var timeline_1 = require("../timeline");
/**
 * @extends Component<TimelineBody.propTypes>
 */
var TimelineBody = /** @class */ (function (_super) {
    __extends(TimelineBody, _super);
    function TimelineBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimelineBody.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    TimelineBody.prototype.shouldComponentUpdate = function (nextProps) {
        var props = this.props;
        if (!props.shallowUpdateCheck) {
            return true;
        }
        if (props.columnCount !== nextProps.columnCount) {
            return true;
        }
        // prettier-ignore
        var shallowChange = props.height !== nextProps.height
            || props.width !== nextProps.width
            || props.rowCount !== nextProps.rowCount;
        if (props.forceRedrawFunc) {
            return shallowChange || props.forceRedrawFunc(props, nextProps);
        }
        return shallowChange;
    };
    TimelineBody.prototype.render = function () {
        var _a = this.props, width = _a.width, columnWidth = _a.columnWidth, height = _a.height, rowHeight = _a.rowHeight, rowCount = _a.rowCount, columnCount = _a.columnCount, onScroll = _a.onScroll, componentId = _a.componentId;
        var _b = this.props, grid_ref_callback = _b.grid_ref_callback, cellRenderer = _b.cellRenderer;
        return ((0, jsx_runtime_1.jsx)(react_virtualized_1.Grid, { containerProps: { 'data-testid': this.props.componentId + '_' + timeline_1.timelineTestids.ganttBody }, ref: grid_ref_callback, autoContainerWidth: true, cellRenderer: cellRenderer, columnCount: columnCount, columnWidth: columnWidth, height: height, rowCount: rowCount, rowHeight: rowHeight, width: width, className: "rct9k-grid rct9k-grid-id-".concat(componentId), onScroll: onScroll, "data-testid": this.props.componentId + '_' + timeline_1.timelineTestids.grid }));
    };
    return TimelineBody;
}(react_1.Component));
TimelineBody.propTypes = {
    /**
     * The total width of the body; mandatory field.
     * @type { number }
     */
    width: prop_types_1.default.number.isRequired,
    /**
     * Function that returns the width of each column, mandatory field.
     * @type { Function }
     */
    columnWidth: prop_types_1.default.func.isRequired,
    /**
     * The total number of columns, including the timeline (gantt).
     * @type { number }
     */
    columnCount: prop_types_1.default.number,
    /**
     * The total height of the body (without timebar), mandatory field.
     * @type { number }
     */
    height: prop_types_1.default.number.isRequired,
    /**
     * Function that returns the height for each row, mandatory field.
     * @type { Function }
     */
    rowHeight: prop_types_1.default.func.isRequired,
    /**
     * Number of rows in timeline, mandatory field.
     * @type { number }
     */
    rowCount: prop_types_1.default.number.isRequired,
    /**
     * @type { Function }
     */
    grid_ref_callback: prop_types_1.default.func.isRequired,
    /**
     * Renderer for each cell of the grid.
     * @type { Function }
     */
    cellRenderer: prop_types_1.default.func.isRequired,
    /**
     * As e.g. @see Timeline.props.shallowUpdateCheck
     * @type { boolean }
     */
    shallowUpdateCheck: prop_types_1.default.bool,
    /**
     * As e.g. @see Timeline.props.forceRedrawFunc
     * @type { Function }
     */
    forceRedrawFunc: prop_types_1.default.func,
    /**
     * A unique key to identify the component. Only needed when 2 grids are mounted.
     * @type { string }
     */
    componentId: prop_types_1.default.string
};
TimelineBody.defaultProps = {
    columnCount: 1,
    shallowUpdateCheck: false,
    forceRedrawFunc: null
};
exports.default = TimelineBody;
//# sourceMappingURL=body.js.map